/**
 * Objeto de configuración de constantes para el entorno de producción (https://unitysecure.es).
 *
 * Centraliza los valores que varían dependiendo del ecosistema de ejecución (Local, Testing, Producción).
 * Angular utiliza este archivo durante el proceso de compilación para inyectar los valores correspondientes
 * mediante la estrategia de "file replacements" definida en el archivo `angular.json`.
 * * @example
 * // Uso típico en un servicio:
 * const url = environment.apis.baseURL;
 */
/**
 * Configuración de variables de entorno para producción.
 *
 * Las rutas son relativas al dominio: el nginx del contenedor `frontend` sirve la web y reenvía
 * `/api`, `/uploads` y `/descargar` al backend, así que funcionan igual con `unitysecure.es`,
 * `www.unitysecure.es` o cualquier otro dominio que se añada, sin CORS.
 */
export const environment = {
  production: true,

  /** Agrupación de configuraciones relativas a las interfaces de programación de aplicaciones (APIs). */
  apis: {
    /** * Punto de entrada principal (endpoint base) para los servicios REST del backend.
     * Se resuelve contra el dominio actual (https://unitysecure.es/api) y nginx lo reenvía al backend.
     */
    baseURL: '/api',
    imagenesURL: '/uploads',
    archivosURL: '/uploads/boletines',
    descargasURL: '/descargar/boletines',
  },
};
